import { render, staticRenderFns } from "./receita.vue?vue&type=template&id=5d22fa7e&scoped=true"
import script from "./receita.vue?vue&type=script&lang=js"
export * from "./receita.vue?vue&type=script&lang=js"
import style0 from "./receita.vue?vue&type=style&index=0&id=5d22fa7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22fa7e",
  null
  
)

export default component.exports